// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__7+fid","preloader":"avatar_preloader__WbR5I","buttonAvatar":"avatar_buttonAvatar__gqO5m","caret":"avatar_caret__hDjXx"};